import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {connect} from "react-redux";
import { useForm } from "react-hook-form";


// components
import RestrictionLangs from "./_langs";
import { CustomMiniButtonX, GenericTableButton } from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, INTERNATIONAL, REQUIRED
} from "../../../components/i18n/i18n";
import { FL_STATUS} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services & providers
import {restrictionService} from "../../../jwt/_services/clasificator/restrictionService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

// actions
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {utilHelper} from "../../../jwt/_helpers";

const RestrictionForm = props => {
    const { editMode, domainObject } = props.formProps;
    const translatableLangs = domainObject?.translatedLangs || []
    const { app } = props.mainProps;

    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject?.status : true);

    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `restriction_` + getCurrentDateForCodeField()),

            icon: domainObject?.icon,
            colorHex: domainObject?.colorHex
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  {  id : app?.fbDataBase?.id },
            item: {
                ...data,
                status      : status,
                colorRgb    : utilHelper.hexToRGB(data.colorHex),
                langs       : langs,
            }
        };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(restrictionService, id, dataRequest)
        } else {
            genericActions.save(restrictionService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }


    return (<>
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>{FORM}
                    <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_SAVE}
                            icon={'fa-save'}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        }
                        <CustomMiniButtonX
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Icono</Label>
                                <Input type="text"
                                       name="icon"
                                       placeholder="Icono"
                                       innerRef={register}
                                />
                            </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Color</Label>
                                    <br/>
                                    <Input type="color"
                                           name="colorHex"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{FL_STATUS}</Label>
                                    <br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            value={status}
                                            onChange={_ => setStatus(!status)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-language mr-2"/>{ INTERNATIONAL }
                        </CardTitle>
                        <CardBody>
                            <RestrictionLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </CardBody>
                </CardBody>
            </Card>
            </Form>

            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(RestrictionForm)